<template>
    <VAppBar id="sr-header" app clipped-left elevation="0" height="67">
        <router-link :to="href" class="sr-header-link">
            <VContainer class="sr-marketplace ml-0 mr-0 pr-3">
                <SrBrandLogo />
                <div class="sr-header-divider" />
                <span class="sr-header-title">{{ title }}</span>
            </VContainer>
        </router-link>
        <VContainer class="sr-marketplace-sub-title flex-grow ml-0 pt-3 pl-5 pb-2">
            <span class="sr-header-sub-title d-inline-block">{{ subTitle }}</span>
        </VContainer>
    </VAppBar>
</template>

<script>
import { SrBrandLogo } from '../../components/SrBrandLogo';

export default {
    name: 'SrHeader',
    components: {
        SrBrandLogo,
    },

    props: {
        title: {
            type: String,
            required: true,
        },
        subTitle: {
            type: String,
            required: false,
            default: '',
        },
        href: {
            type: String,
            default: '/onboarding',
        },
    },
};
</script>
